/* global app: false, $: false, dataLayer: false */
app.controller('Datalayer.CallMeBackForm.Controller', function () {
    var form = $('.callmeback form');

    if (form.length) {
        $(form).on('submit', function () {
            try {
                if (dataLayer) {
                    dataLayer.push({
                        event: 'callmebackform submit',
                    });
                }
            } catch (e) {
                console.log('Could not push to Datalayer - CallMeBack Form Submit');
            }
        });
    }
});
